"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "safetyonsurface",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        },
        {
            sort_no: 2,
            name: "safetyoncapacity",
            group: "",
            quantity: "Dimensionless",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: []
        }
    ];
}
//# sourceMappingURL=safety-definition.js.map